export const SDI_STRATEGIES_EVENT_NAMES = {
  CLICKED_GENERATE: 'Clicked Generate SDI Strategies',
  CLICKED_START_OVER: 'Clicked Start Over SDI Strategies',
  CLICKED_CLEARED: 'Clicked Cleared SDI Strategies',
  OPENED_AI_DISCLAIMER: 'Opened AI Disclaimer Modal',
}
